import { $$, REDUCED } from '../lib/dom.js';

export function initH2Reveal() {
  const targets = $$('.section h2, .recruit h2');
  if (REDUCED) {
    targets.forEach(t => t.classList.add('is-in'));
    return;
  }
  targets.forEach(t => t.classList.add('rv'));
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.2 });
  targets.forEach(t => io.observe(t));
}
